"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var utils_1 = require("../../utils");
var Pill = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    border-width: ", ";\n    border-color: ", ";\n    border-radius: ", ";\n    border-style: solid;\n    color: ", ";\n    display: inline-flex;\n    font-size: ", ";\n    text-transform: ", "\n"], ["\n    background-color: ",
    ";\n    border-width: ", ";\n    border-color: ",
    ";\n    border-radius: ", ";\n    border-style: solid;\n    color: ",
    ";\n    display: inline-flex;\n    font-size: ", ";\n    text-transform: ", "\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, backgroundColorDisabled = _a.backgroundColorDisabled, disabled = _a.disabled, theme = _a.theme;
    return disabled ? utils_1.parseThemePath(backgroundColorDisabled, theme, colors_1.colors.GREY_250) :
        utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var borderWidth = _a.borderWidth, theme = _a.theme;
    return utils_1.parseThemePath(borderWidth, theme, '0');
}, function (_a) {
    var borderColor = _a.borderColor, disabled = _a.disabled, borderColorDisabled = _a.borderColorDisabled, theme = _a.theme;
    return disabled ? utils_1.parseThemePath(borderColorDisabled, theme, colors_1.colors.WHITE)
        : utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius ? borderRadius : '18px';
}, function (_a) {
    var color = _a.color, colorDisabled = _a.colorDisabled, disabled = _a.disabled, theme = _a.theme;
    return disabled ? utils_1.parseThemePath(colorDisabled, theme, colors_1.colors.WHITE)
        : utils_1.parseThemePath(color, theme, colors_1.colors.WHITE);
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
}, function (_a) {
    var textTransform = _a.textTransform;
    return textTransform ? textTransform : 'inherit';
});
var ContentWrapper = styled_components_1.default(AXSFlex_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  line-height: ", ";\n  font-weight: bold;\n  letter-spacing: ", ";\n  text-transform: ", ";\n"], ["\n  line-height: ", ";\n  font-weight: bold;\n  letter-spacing: ", ";\n  text-transform: ", ";\n"])), function (_a) {
    var variant = _a.variant;
    return variant && variant.includes('ribbon') ? '0' : 1;
}, function (_a) {
    var variant = _a.variant;
    return variant && variant.includes('ribbon') ? '3px' : 'inherit';
}, function (_a) {
    var variant = _a.variant;
    return variant && variant.includes('ribbon') ? 'uppercase' : 'inherit';
});
var InlineFlex = styled_components_1.default(AXSFlex_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-flex;\n"], ["\n  display: inline-flex;\n"])));
var RibbonEdge = function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme, direction = _a.direction;
    return (React.createElement("svg", { width: "15px", height: "20px", x: "0px", y: "0px", viewBox: "0 0 15 20" }, direction === 'left' ?
        // tslint:disable-next-line:max-line-length
        React.createElement("polygon", { fill: utils_1.parseThemePath(backgroundColor, theme, ''), className: "st0", points: "15,20 0,20 8,10 0,0 15,0 " }) :
        // tslint:disable-next-line:max-line-length
        React.createElement("polygon", { fill: utils_1.parseThemePath(backgroundColor, theme, ''), className: "st0", points: "0,0 0,20 15,20 8,10 15,0 " })));
};
var AXSLabel = function (_a) {
    var backgroundColor = _a.backgroundColor, backgroundColorDisabled = _a.backgroundColorDisabled, borderColor = _a.borderColor, borderColorDisabled = _a.borderColorDisabled, borderRadius = _a.borderRadius, borderWidth = _a.borderWidth, children = _a.children, className = _a.className, color = _a.color, disabled = _a.disabled, disabledColor = _a.disabledColor, fontSize = _a.fontSize, padding = _a.padding, textTransform = _a.textTransform, theme = _a.theme, variant = _a.variant, position = _a.position, props = __rest(_a, ["backgroundColor", "backgroundColorDisabled", "borderColor", "borderColorDisabled", "borderRadius", "borderWidth", "children", "className", "color", "disabled", "disabledColor", "fontSize", "padding", "textTransform", "theme", "variant", "position"]);
    return (React.createElement(InlineFlex, { justifyContent: "flex-start" },
        variant === 'ribbon-start' &&
            React.createElement(RibbonEdge, { direction: "left", theme: theme, backgroundColor: backgroundColor }),
        React.createElement(Pill, __assign({}, props, { backgroundColor: backgroundColor, backgroundColorDisabled: backgroundColorDisabled, borderColor: borderColor, borderColorDisabled: borderColorDisabled, borderRadius: variant && variant.includes('ribbon') ? '0' : borderRadius, borderWidth: variant && variant.includes('ribbon') ? '0' : borderWidth, className: classnames_1.default(['c-axs-pill', className]), color: color, disabled: disabled, disabledColor: disabledColor, justifyContent: "center", textTransform: textTransform, fontSize: variant && variant.includes('ribbon') ? '8px' : fontSize, padding: variant && variant === 'ribbon-start' ? '0 10px 0 0' : variant === 'ribbon-end' ? '0 0 0 10px' : '0' }),
            React.createElement(ContentWrapper, { alignContent: "center", alignItems: "center", height: variant && variant.includes('ribbon') ? '20px' : 'auto', backgroundColor: "transparent", padding: variant && variant.includes('ribbon') ? '0' : padding, variant: variant }, children)),
        variant === 'ribbon-end' &&
            React.createElement(RibbonEdge, { direction: "right", theme: theme, backgroundColor: backgroundColor })));
};
AXSLabel.defaultProps = {
    backgroundColor: 'axsui.components.label.backgroundColor',
    backgroundColorDisabled: 'axsui.components.label.backgroundColorDisabled',
    borderColor: 'axsui.components.label.borderColor',
    borderColorDisabled: 'axsui.components.label.borderColorDisabled',
    borderRadius: '18px',
    borderWidth: '1px',
    color: 'axsui.components.label.color',
    colorDisabled: 'axsui.components.label.colorDisabled',
    fontSize: '20px',
    padding: '8px 12px',
};
exports.default = styled_components_1.withTheme(AXSLabel);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map